import { lazy } from "react";
import { Navigate } from "react-router-dom";

const MyAccountDetailsPage = lazy(() =>
  import("pages/account/MyAccountDetailsPage")
);

const DeviceCreatePage = lazy(() => import("pages/devices/DeviceCreatePage"));
const DeviceDetailsPage = lazy(() => import("pages/devices/DeviceDetailsPage"));
const DeviceEditPage = lazy(() => import("pages/devices/DeviceEditPage"));
const DeviceListPage = lazy(() => import("pages/devices/DeviceListPage"));

const EventDetailsPage = lazy(() => import("pages/events/EventDetailsPage"));
const EventEditPage = lazy(() => import("pages/events/EventEditPage"));
const EventsCreatePage = lazy(() => import("pages/events/EventsCreatePage"));
const EventsListPage = lazy(() => import("pages/events/EventsListPage"));
const TrackEventsPage = lazy(() => import("pages/venues/TrackEventsPage"));
const UserConnectionsPage = lazy(() =>
  import("pages/users/UserConnectionsPage")
);
const UserProfilePage = lazy(() => import("pages/users/UserProfilePage"));

const EventDeviceDetailsPage = lazy(() =>
  import("pages/eventDevice/EventDeviceDetailsPage")
);
const EventDeviceCreatePage = lazy(() =>
  import("pages/eventDevice/EventDeviceCreatePage")
);
const EventDeviceEditPage = lazy(() =>
  import("pages/eventDevice/EventDeviceEditPage")
);
const ExportListPage = lazy(() => import("pages/exports/ExportListPage"));
const ImportListPage = lazy(() => import("pages/imports/ImportListPage"));
const ImportCreatePage = lazy(() => import("pages/imports/ImportCreatePage"));
const ImportWizardPage = lazy(() => import("pages/imports/ImportWizardPage"));
const ImportDetailsPage = lazy(() => import("pages/imports/ImportDetailsPage"));

const PlanListPage = lazy(() => import("pages/subscriptions/PlanListPage"));
const MyTracksPage = lazy(() => import("pages/venues/MyTracksPage"));
const TeamsPage = lazy(() => import("pages/teams/TeamsPage"));
const TeamDetailsPage = lazy(() => import("pages/teams/TeamDetailsPage"));
const WorkspacesPage = lazy(() => import("pages/analysis/WorkspacesPage"));
const WorkspacePage = lazy(() => import("pages/analysis/WorkspacePage"));

const FeedPage = lazy(() => import("pages/feed/FeedPage"));
const HelpPage = lazy(() => import("pages/help/HelpPage"));

export default [
  //
  // Feed
  {
    path: "",
    element: <FeedPage />,
  },
  {
    path: "feed",
    element: <Navigate to="/" />,
  },
  //
  // Events
  {
    path: "events",
    element: <EventsListPage />,
  },
  {
    path: "events/create",
    element: <EventsCreatePage />,
  },
  {
    path: "events/:id",
    element: <EventDetailsPage />,
  },
  {
    path: "events/:id/edit",
    element: <EventEditPage />,
  },
  {
    path: "users/:slug",
    element: <UserProfilePage />,
  },
  {
    path: "users/:slug/followers",
    element: <UserConnectionsPage />,
  },
  {
    path: "users/:slug/following",
    element: <UserConnectionsPage />,
  },
  {
    path: "events/:id/eventDevices/create",
    element: <EventDeviceCreatePage />,
  },
  //
  // Devices
  {
    path: "devices",
    element: <DeviceListPage />,
  },
  {
    path: "devices/create",
    element: <DeviceCreatePage />,
  },
  {
    path: "devices/:id",
    element: <DeviceDetailsPage />,
  },
  {
    path: "devices/:id/edit",
    element: <DeviceEditPage />,
  },
  {
    path: "teams",
    element: <TeamsPage />,
  },
  {
    path: "teams/:id",
    element: <TeamDetailsPage />,
  },
  {
    path: "tracks",
    element: <MyTracksPage />,
  },
  {
    path: "tracks/:venueId/events",
    element: <TrackEventsPage />,
  },
  //
  // Analysis workspaces
  {
    path: "analysis",
    element: <WorkspacesPage />,
  },
  {
    path: "analysis/:workspaceId",
    element: <WorkspacePage />,
  },
  //
  // Event device
  {
    path: "eventdevice/:id",
    element: <EventDeviceDetailsPage />,
  },
  {
    path: "eventdevice/:id/edit",
    element: <EventDeviceEditPage />,
  },
  //
  // Exports
  {
    path: "exports",
    element: <ExportListPage />,
  },
  //
  // Imports
  {
    path: "imports",
    element: <ImportListPage />,
  },
  {
    path: "imports/create",
    element: <ImportCreatePage />,
  },
  {
    path: "imports/wizard",
    element: <ImportWizardPage />,
  },
  {
    path: "imports/wizard/:sessionId",
    element: <ImportWizardPage />,
  },
  {
    path: "imports/:id",
    element: <ImportDetailsPage />,
  },
  //
  // Imports
  {
    path: "imports",
    element: <ImportListPage />,
  },
  {
    path: "imports/create",
    element: <ImportCreatePage />,
  },
  {
    path: "imports/:id",
    element: <ImportDetailsPage />,
  },
  //
  // Account
  {
    path: "account",
    element: <MyAccountDetailsPage />,
  },
  //
  // Plans
  {
    path: "plans",
    element: <PlanListPage />,
  },
  //
  // Tutorials
  {
    path: "help",
    element: <HelpPage />,
  },
];
